var map = {
	"./flavours.jpg": "1fcb",
	"./juice-concentrates.jpg": "2113",
	"./juice.jpg": "09d4",
	"./organic-products.jpg": "def6",
	"./puree-concentrates.jpg": "1cde",
	"./puree.jpg": "20c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4729";